module.exports = __webpack_public_path__ + "img/join-top-phone.920f4d04.png";